import AddFeatureFlagForm  from '../components/Forms/AddFeatureFlagForm';

function AddFeatureFlagPage() {
    
    return <section style={{margin: "20px"}}>
        <h1>Add a Feature Flag</h1>

        <AddFeatureFlagForm />
    </section>
}

export default AddFeatureFlagPage;